import store from '@/store';

export default async (to, from, next) => {
  if (store.getters['auth/isLogged']) {
    await store.dispatch('user/loadCheckoutAndBalance');
  }

  next();
};
